// @flow
import React, { Component } from 'react';
import type { RouterHistory } from 'react-router-dom';
import { Link } from 'react-router-dom';
import type { User } from 'gwu';
import Grid from '@material-ui/core/Grid';
import classNames from 'classnames';
import { withStyles } from '@material-ui/core/styles';
import Dropdown from './Dropdown';
import { brandColor } from '../../styles/style-constants';
import { remCalc, getPhoneMediaQueriedStyle } from '../../util/style-util';
import logoLight from '../../images/grow-logo-light.png';
import wordLogoLight from '../../images/grow-word-logo-light.png';
import growWordLogoBlack from '../../images/grow-word-logo-black.png';
import moreIcon from '../../images/more-logo.png';
import RightsUtil from '../../util/rights-util';

type Props = {
  lang: any,
  classes: Object,
  history: RouterHistory,
  userProfile: User,
  omitBackground?: boolean,
  showLogout: boolean,
  onLogout: () => void,
  onViewOnBoarding: () => void
}

class GwuHeader extends Component<Props> {
  handleProfileClick = () => {
    this.props.history.push('/profile');
  }

  handleLogout = () => {
    this.props.onLogout();
  }

  handleViewOnBoarding = () => {
    this.props.onViewOnBoarding();
  }

  handleAdminClick = () => {
    this.props.history.push('/admin');
  }

  renderAuthNavItems = () => {
    const { userProfile, lang, classes } = this.props;
    if (!userProfile) {
      return null;
    }

    const moreIconEl = (
      <img
        className={classes.img}
        src={moreIcon}
        alt={'Menu'}
      />
    );

    const menuItems = [
      { display: lang.t('header.profile'), onClick: this.handleProfileClick }
    ];

    if (RightsUtil.canAccessAdmin(userProfile.rights)) {
      menuItems.push({ display: lang.t('header.admin'), onClick: this.handleAdminClick });
    }
    
    if (this.props.showLogout) {
      menuItems.push({ display: lang.t('header.onboard'), onClick: this.handleViewOnBoarding })
      menuItems.push({ display: lang.t('header.logout'), onClick: this.handleLogout })
    }

    return (
      <div className={classes.menuContainer}>
        <Dropdown menuEl={moreIconEl} menuItems={menuItems} />
      </div>
    );
  }

  render() {
    const { omitBackground, classes } = this.props;

    const navBarClass = omitBackground ? classes.header : classNames(classes.header, classes.headerColor);

    return (
      <div className={navBarClass}>
        <Grid container spacing={32}>
          <Grid item xs={10}>
            <div>
              <Link
                smooth="true"
                className={classes.back}
                to={'/'}
              >
                <img
                  className={classes.logoImgPrint}
                  src={growWordLogoBlack}
                  alt={'TAKECARE GROW Word Logo'}
                />
                <img
                  className={classes.logoImg}
                  src={logoLight}
                  alt={'TAKECARE GROW Logo'}
                />
                <img
                  className={classes.wordLogoImg}
                  src={wordLogoLight}
                  alt={'TAKECARE GROW Word Logo'}
                />
              </Link>
            </div>
          </Grid>
          <Grid item xs={2}>
            {this.renderAuthNavItems()}
          </Grid>
        </Grid>
      </div>
    );
  }
}

const styles = {
  header: {
    padding: remCalc(20, 135),
    ...getPhoneMediaQueriedStyle({
      padding: remCalc(15, 20)
    }),
    backgroundImage: 'linear-gradient(-179deg, #5A3F98 0%, rgba(110,25,230,0.00) 76%)',
    '@media print': {
      backgroundImage: 'none',
      padding: remCalc(20, 0)
    }
  },
  headerColor: {
    backgroundColor: brandColor,
    '@media print': {
      backgroundColor: 'transparent'
    }
  },
  logoImg: {
    verticalAlign: 'baseline',
    ...getPhoneMediaQueriedStyle({
      width: remCalc(45)
    }),
    '@media print': {
      display: 'none'
    }
  },
  wordLogoImg: {
    verticalAlign: 'baseline',
    marginLeft: remCalc(20),
    ...getPhoneMediaQueriedStyle({
      width: '65%'
    }),
    '@media print': {
      display: 'none'
    }
  },
  logoImgPrint: {
    display: 'none',
    verticalAlign: 'baseline',
    '@media print': {
      display: 'block'
    }
  },
  menuContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    height: '100%',
    '@media print': {
      display: 'none'
    }
  },
  img: {
    cursor: 'pointer',
  }
};

export default withStyles(styles)(GwuHeader);



// WEBPACK FOOTER //
// ./src/components/core/GwuHeader.js